export default "__VITE_ASSET__C6myIp7e__"